import { useContext } from 'react'
import { ExitUnsavedFormsContext } from '../provider/ExitUnsavedFormsContext'
import type { UnsavedFormProps } from '../provider/types'

/**
 * This hook provides the context ExitUnsavedFormsContext
 */
export const useExitUnsavedFormContext = <T>(): UnsavedFormProps<T> | undefined => {
  return useContext(ExitUnsavedFormsContext)
}
